import { axios } from "@v2/shared/api";
const PARTICIPANT_ENDPOINT = "participants";
const CATEGORIES_ENDPOINT = "categories";

export default {
  all(eventId) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CATEGORIES_ENDPOINT}`
    );
  },

  getCategory(eventId, categoryId) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CATEGORIES_ENDPOINT}/${categoryId}`
    );
  }
};
